export let formErrors = {
  data() {
    return {
      errors: {
        login_err: "نام کاربری یا کلمه عبور اشتباه است.",
        login_fail: "نام کاربری یا کلمه عبور اشتباه است.",
        active_fail: "نام کاربری یا کلمه عبور اشتباه است.",
        active_fail_ip_blacklist: "active_fail_ip_blacklist",
        login_fail_ip_blacklist: "login_fail_ip_blacklist",
        password_empty_err: "رمز عبور نباید خالی باشد.",
        user_err: "user_err",
        user_active_err: "user_active_err",
        same_title_err: "same_title_err",
        address_pack_err: "address_pack_err",
        '11': "کد 4 حرفی وارد شده اشتباه است.",
        ip_blacklist: "تا 24 ساعت امکان ورود به سایت را ندارید.",
        empty_err: "تمامی فیلد ها را پر کنید.",
        logged_in: "با موفقیت وارد شدید.",
        already_logged_in: "با موفقیت وارد شدید.",
        login_err_ip_blacklist: "login_err_ip_blacklist",
        password_min_length_err: "password_validate_err",
        password_validate_err: "رمز وارد شده ضعیف است.",
        password_confirm_err: "password_confirm_err",
        pre_mobile_max_length_err: "pre_mobile_max_length_err",
        mobile_validate_err: "شماره همراه اشتباه است.",
        mobile_unique_err: "شماره همراه قبلا ثبت شده است.",
        code_unique_err: "کد ملی قبلا ثبت شده است.",
        code_validate_err: "کد ملی به درستی وارد نشده است.",
        register_err: "register_err",
        validate_err: "validate_err",
        failure: "failure",
        session_err: "session_err",
        expired: "expired",
        unable_to_set: "unable_to_set",
        ignore_value: "ignore_value",
        user_business_owner_err: "user_business_owner_err",
        uniq_username_err: "این نام کاربری قبلا انتخاب شده است."
      }
    }
  }
}

export let url = {
  data() {
    return {
      basicUrl: process.env.VUE_APP_IMG_URL,
      url: process.env.VUE_APP_IMG_URL + 'assets/images/eduaid/',
      documentUrl: process.env.VUE_APP_IMG_URL + 'assets/documents/eduaid/',
      defaultUrl: process.env.VUE_APP_IMG_URL + 'assets/images/default/eduaid/'
    }
  },
}

/**
 * getImageUrl
 *
 * @param {string} imageName The name of image.
 * @param {string} folder The folder that image located.
 * @param {string} defaultImageName The name of an alternate image if imageName not exist.
 * @return {string} A image URL.
 */
export let getImageUrl = {
  methods: {
    getImageUrl(imageName, folder, defaultImageName) {
      let src = ""

      if (imageName) {
        src = `${this.url}${folder}/${imageName}`;
      } else {
        src = `${this.defaultUrl}${defaultImageName}`;
      }

      return src;
    }
  }
}

export default formErrors